import request from "@/utils/request";

export function login(data) {
  return request({
    url: "/user/login",
    method: "post",
    data,
  });
}

export function dingtalkLogin(data) {
  return request({
    url: "/dingtalk/auth",
    method: "post",
    data,
  });
}

export function register(data) {
  return request({
    url: "/user/register",
    method: "post",
    data,
  });
}

export function getInfo() {
  return request({
    url: "/user/info",
    method: "get",
  });
}

export function updateInfo(data) {
  return request({
    url: "/user/info",
    method: "patch",
    data,
  });
}
